<template>
  <CRow>
    <!-- TODO Criar um layout para unificar com recover -->
    <CCol v-if="status == 'loading'">
      <div class="d-flex justify-content-center align-items-center mb-3" style="height: 100%">
        <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
      </div>
    </CCol>

    <CForm autocomplete="off" @submit.prevent="submit" v-show="status !== 'loading'">
      <template v-if="isExpiredPassword">
        <CAlert maxlength="255" color="warning" closeButton>
          {{ $t('general.errors.PASSWORD_EXPIRED') }}
        </CAlert>
      </template>
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <h1 class="mb-5">{{ $t('auth.newPassword.title.newPassword') }}</h1>
      <CRow>
        <CCol md="6">
          <CForm autocomplete="off">
            <CInput
              class="mb-0"
              :label="$t('auth.PASSWORD')"
              :type="typeInputPassword"
              addLabelClasses="mt-1 required"
              :value.sync="$v.password.$model"
              :isValid="checkIfValid('password')"
              :invalidFeedback="'Required'"
              id="password"
              v-focus="focused"
              @focus="focused = true"
              @blur="focused = false"
              autocomplete="off"
              :placeholder="$t('auth.PASSWORD')"
            >
              <template #append>
                <CButton @click="showPassword">
                  <i class="far" :class="`fa-${iconInputPassword}`"></i>
                </CButton>
              </template>
            </CInput>
          </CForm>
          <div v-show="focused" class="text-muted checkPassword">
            <p class="text-muted mb-1">The password must have:</p>
            <ul class="p-0 font-smaller checkPassword__list">
              <li v-for="(item, i) in listCheckPassword" :key="i" class="font-smaller checkPassword__item" :class="{ 'is-valid': item.isValid }">
                * {{ item.name }}
              </li>
            </ul>
          </div>
        </CCol>
        <CCol md="6">
          <CForm autocomplete="off">
            <CInput
              @paste="onPaste"
              class="mb-0"
              label="Confirm Password"
              type="password"
              addLabelClasses="mt-1 required"
              :value.sync="$v.confirmPassword.$model"
              :isValid="checkIfValid('confirmPassword')"
              :invalidFeedback="'Password comfirm invalid!'"
              id="confirmPassword"
              :placeholder="$t('auth.newPassword.label.confirm')"
              autocomplete="false"
            />
          </CForm>
        </CCol>
        <CCol sm="12" md="6" class="mt-5">
          <CButton :disabled="!isValid || submitted" type="submit" class="btn-primary btn-block font-weight-bold ml-0 mt-4">
            {{ $t('auth.newPassword.button.submit') }}
          </CButton>
        </CCol>
      </CRow>
    </CForm>
  </CRow>
</template>

<script>
import { mixin as focusMixin } from 'vue-focus'
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import MenssageAlert from '@/components/MenssageAlert'
export default {
  name: 'NewPassword',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      typeInputPassword: 'password',
      submitted: false,
      messages: [],
      focused: false,
      confirmPassword: null,
      password: null,
      isExpiredPassword: false,
      listCheckPassword: {
        hasLowerCase: { name: this.$t('general.components.rules-password.one-lowercase-character'), isValid: false },
        hasSpecial: { name: this.$t('general.components.rules-password.one-special-character'), isValid: false },
        hasUppercase: { name: this.$t('general.components.rules-password.one-uppercase-character'), isValid: false },
        hasMinNumber: { name: this.$t('general.components.rules-password.caracters-minimun'), isValid: false },
        hasNumber: { name: this.$t('general.components.rules-password.one-number'), isValid: false },
      },
    }
  },
  mixins: [validationMixin, focusMixin],
  validations: {
    password: {
      required,
      strongPassword(password) {
        return (
          /[a-z]/.test(password) && // checks for a-z
          /[A-Z]/.test(password) && // checks for A-Z
          /[0-9]/.test(password) && // checks for 0-9
          /\W|_/.test(password) && // checks for special char
          password.length >= 8
        )
      },
    },
    confirmPassword: {
      sameAsPassword: sameAs('password'),
    },
  },
  mounted() {
    if (this.$route.query.expired) {
      this.isExpiredPassword = true
    }
  },
  methods: {
    onPaste(evt) {
      evt.preventDefault()
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },
    submit() {
      if (!this.isValid) {
        return
      }

      this.messages = []

      const obj = {
        id: this.$route.query.id,
        newPassword: this.password,
        passwordResetToken: this.$route.query.token,
      }

      this.$store
        .dispatch('auth/newPassword', obj)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('auth.newPassWord.messages.changed-success'),
          })
          setTimeout(() => {
            this.$router.push({ name: 'Login' })
          }, 1500)
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
    },

    //TODO add a um mixin ou component
    showPassword() {
      if (this.typeInputPassword === 'password') {
        this.typeInputPassword = 'text'
      } else {
        this.typeInputPassword = 'password'
      }
    },
  },
  watch: {
    password: {
      handler() {
        this.listCheckPassword.hasLowerCase.isValid = /[a-z]/.test(this.password) ? true : null
        this.listCheckPassword.hasUppercase.isValid = /[A-Z]/.test(this.password) ? true : null
        this.listCheckPassword.hasNumber.isValid = /[0-9]/.test(this.password) ? true : null
        this.listCheckPassword.hasSpecial.isValid = /\W|_/.test(this.password) ? true : null
        this.listCheckPassword.hasMinNumber.isValid = this.password.length >= 8 ? true : null
      },
    },
  },
  computed: {
    isValid() {
      return !this.$v.$invalid
    },
    iconInputPassword() {
      return this.typeInputPassword === 'password' ? 'eye-slash' : 'eye'
    },
    status() {
      return this.$store.getters['auth/authStatus']
    },
  },
}
</script>

<style></style>
